import { api } from "@/services/api"
import { benefitEndpointDefinitions, benefitTagTypes } from "./benefitEndpointDefinitions"

/** Reuses the one staff cache/middleware; never the public booking API. */
export const benefitApi = api.enhanceEndpoints({ addTagTypes: [...benefitTagTypes] }).injectEndpoints({
  endpoints: benefitEndpointDefinitions,
})
